import {SaleVehicleFinancingConfiguration, SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

interface ConfigurationToFinancingBodyOptions {
  isGermanTenant: boolean;
}

/**
 * Maps the persisted configuration back into the save body the editor works on.
 *
 * A German manual configuration saved without an interest rate type gets the fixed rate the field
 * shows for it, so the next save stores the value the user sees (see `createManualFinancingBody`).
 */
export function configurationToFinancingBody(
  configuration: SaleVehicleFinancingConfiguration,
  options: ConfigurationToFinancingBodyOptions
): SaveSaleVehicleFinancingBody {
  return {
    type: configuration.type,
    mode: configuration.mode,
    templateId: configuration.templateId,
    financialInstitutionCodeId:
      configuration.mode === 'MANUAL' ? configuration.financialInstitutionCodeId : null,
    validTo: configuration.mode === 'MANUAL' ? configuration.validTo : null,
    // Copied, not shared: `configuration` is RTK Query cache data. The panel replaces this array
    // wholesale on every cell edit (never mutates a cell in place), but holding the cache's own
    // array reference here would still let an in-place mutation elsewhere reach the cache.
    rateMatrix: {
      availableTerms: [...configuration.availableTerms],
      cells: [...configuration.rateMatrixCells],
    },
    activeTerm: configuration.activeTerm,
    activeDownPayment: configuration.activeDownPayment,
    activeBalloonPayment: configuration.activeBalloonPayment,
    processingFeeOverride: configuration.processingFeeOverride,
    interestRateTypeOverride:
      configuration.mode === 'MANUAL' && options.isGermanTenant
        ? (configuration.interestRateTypeOverride ?? 'FIXED')
        : configuration.interestRateTypeOverride,
    vehicleTransferIncludedOverride: configuration.vehicleTransferIncludedOverride,
    vehicleTransferAmountOverride: configuration.vehicleTransferAmountOverride,
    vehicleRegistrationIncludedOverride: configuration.vehicleRegistrationIncludedOverride,
    vehicleRegistrationAmountOverride: configuration.vehicleRegistrationAmountOverride,
    vehicleDeliveryIncludedOverride: configuration.vehicleDeliveryIncludedOverride,
    vehicleDeliveryAmountOverride: configuration.vehicleDeliveryAmountOverride,
    tradeInPossibleOverride: configuration.tradeInPossibleOverride,
    creditProtectionIncluded: configuration.creditProtectionIncluded,
    insuranceIncludedInCalculation: configuration.insuranceIncludedInCalculation,
    liabilityInsuranceMonthly: configuration.liabilityInsuranceMonthly,
    liabilityInsuranceDeductible: configuration.liabilityInsuranceDeductible,
    comprehensiveInsuranceMonthly: configuration.comprehensiveInsuranceMonthly,
    comprehensiveInsuranceDeductible: configuration.comprehensiveInsuranceDeductible,
  };
}
